type AddCircleIconProps = {
  color?: 'purple' | 'gray' | 'white';
};

function AddCircleIcon({ color = 'purple' }: AddCircleIconProps) {
  const COLORS = {
    purple: 'var(--purple-700)',
    gray: 'var(--gray-600)',
    white: 'white',
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M10.125 0C8.12247 0 6.1649 0.593821 4.49986 1.70637C2.83481 2.81892 1.53706 4.40023 0.770724 6.25033C0.00438702 8.10043 -0.196122 10.1362 0.194554 12.1003C0.585229 14.0643 1.54954 15.8685 2.96555 17.2845C4.38156 18.7005 6.18566 19.6648 8.14971 20.0555C10.1138 20.4461 12.1496 20.2456 13.9997 19.4793C15.8498 18.7129 17.4311 17.4152 18.5436 15.7501C19.6562 14.0851 20.25 12.1275 20.25 10.125C20.247 7.4406 19.1793 4.86699 17.2812 2.96883C15.383 1.07067 12.8094 0.00297771 10.125 0ZM10.125 18C8.56748 18 7.04493 17.5381 5.74989 16.6728C4.45485 15.8075 3.44549 14.5776 2.84945 13.1386C2.25341 11.6997 2.09746 10.1163 2.40132 8.58866C2.70518 7.06106 3.4552 5.65787 4.55654 4.55653C5.65788 3.4552 7.06107 2.70517 8.58867 2.40132C10.1163 2.09746 11.6997 2.25341 13.1386 2.84945C14.5776 3.44549 15.8075 4.45485 16.6728 5.74988C17.5381 7.04492 18 8.56747 18 10.125C17.9978 12.2129 17.1674 14.2146 15.691 15.691C14.2146 17.1674 12.2129 17.9978 10.125 18ZM15 10.125C15 10.4234 14.8815 10.7095 14.6705 10.9205C14.4595 11.1315 14.1734 11.25 13.875 11.25H11.25V13.875C11.25 14.1734 11.1315 14.4595 10.9205 14.6705C10.7095 14.8815 10.4234 15 10.125 15C9.82664 15 9.54049 14.8815 9.32951 14.6705C9.11853 14.4595 9 14.1734 9 13.875V11.25H6.375C6.07664 11.25 5.79049 11.1315 5.57951 10.9205C5.36853 10.7095 5.25 10.4234 5.25 10.125C5.25 9.82663 5.36853 9.54048 5.57951 9.3295C5.79049 9.11853 6.07664 9 6.375 9H9V6.375C9 6.07663 9.11853 5.79048 9.32951 5.5795C9.54049 5.36853 9.82664 5.25 10.125 5.25C10.4234 5.25 10.7095 5.36853 10.9205 5.5795C11.1315 5.79048 11.25 6.07663 11.25 6.375V9H13.875C14.1734 9 14.4595 9.11853 14.6705 9.3295C14.8815 9.54048 15 9.82663 15 10.125Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}

export default AddCircleIcon;
